import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import auth from './routes/auth'
import { isUserLoggedIn, getHomeRouteForLoggedInUser } from '@/auth/utils'

import dashboard from './routes/dashboard'
import contact from './routes/contact'
import notFound from './routes/not-found'
import senderId from './routes/sender-id'
import billing from './routes/billing'
import message from './routes/message'
import user from './routes/user'
// import voice from './routes/voice'
import developer from './routes/developer'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...auth,
    ...dashboard,
    ...billing,
    ...senderId,
    ...contact,
    ...message,
    ...user,
    // ...voice,
    ...notFound,
    ...developer
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if(to.meta.requiresAuth && !isLoggedIn){
    return next({ name: 'login' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    next(getHomeRouteForLoggedInUser("dummy-user"))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router